import { useState } from 'react';
import { Button, Form, Input } from 'antd';
import {
    ArrowRightOutlined,
    CheckCircleFilled,
    EyeInvisibleOutlined,
    EyeTwoTone,
    LockOutlined,
    SafetyCertificateOutlined,
    UserOutlined,
} from '@ant-design/icons';
import { apiCall } from '../../API/RestApi';
import { useNavigate } from 'react-router';
import { modalError } from '../../Component/Modal/ModalLayout';
import { useDispatch } from 'react-redux';
import { MENU_USER } from '../../Redux/actions/userActions';
import './Login.css';

function Login() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);

    const onLogin = (values) => {
        const dataReq = {
            method: 'POST',
            url: '/login',
            data: {
                data: values,
            },
        };

        setLoading(true);
        apiCall(dataReq)
            .then((res) => {
                if (res.status === 'success') {
                    const menudata = res.data.user_role;
                    dispatch(
                        MENU_USER(
                            JSON.stringify(menudata),
                            JSON.stringify(res.data),
                            res.token
                        )
                    );
                    navigate('/dashboard');
                } else {
                    modalError(res.message);
                }
            })
            .catch((e) => {
                console.error(e);
                modalError('Internal Server Error');
            })
            .finally(() => setLoading(false));
    };

    const onFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    return (
        <main className="bolde-login-page">
            <div className="bolde-login-ambient bolde-login-ambient-one" aria-hidden="true" />
            <div className="bolde-login-ambient bolde-login-ambient-two" aria-hidden="true" />

            <section className="bolde-login-shell">
                <aside className="bolde-login-brand-panel">
                    <div className="bolde-login-brand-top">
                        <div className="bolde-login-logo-wrap">
                            <img src="/assets/logo.png" alt="BOLDe Access" className="bolde-login-logo" />
                        </div>
                        <span className="bolde-login-brand-badge">Employee Workspace</span>
                    </div>

                    <div className="bolde-login-brand-copy">
                        <span className="bolde-login-eyebrow">BOLDe Access</span>
                        <h1>Satu akses untuk aktivitas kerja Anda.</h1>
                        <p>
                            Kelola informasi karyawan, kehadiran, pengajuan, KPI, dan kebutuhan operasional
                            melalui satu workspace yang terintegrasi.
                        </p>

                        <div className="bolde-login-feature-list">
                            <div className="bolde-login-feature-item">
                                <CheckCircleFilled />
                                <span>Employee self-service terpusat</span>
                            </div>
                            <div className="bolde-login-feature-item">
                                <CheckCircleFilled />
                                <span>Approval dan monitoring lebih praktis</span>
                            </div>
                            <div className="bolde-login-feature-item">
                                <CheckCircleFilled />
                                <span>Akses aman untuk kebutuhan internal</span>
                            </div>
                        </div>
                    </div>

                    <div className="bolde-login-brand-footer">
                        <SafetyCertificateOutlined />
                        <span>Secure internal access</span>
                    </div>
                </aside>

                <div className="bolde-login-form-panel">
                    <div className="bolde-login-mobile-brand">
                        <img src="/assets/logo.png" alt="BOLDe Access" />
                        <span>BOLDe Access</span>
                    </div>

                    <div className="bolde-login-form-box">
                        <div className="bolde-login-form-heading">
                            <span className="bolde-login-welcome-pill">Welcome back</span>
                            <h2>Masuk ke akun Anda</h2>
                            <p>Gunakan akun BOLDe Access untuk melanjutkan ke dashboard.</p>
                        </div>

                        <Form
                            name="login"
                            layout="vertical"
                            onFinish={onLogin}
                            onFinishFailed={onFailed}
                            autoComplete="off"
                            requiredMark={false}
                            className="bolde-login-form"
                        >
                            <Form.Item
                                label="Email"
                                name="email"
                                rules={[
                                    { required: true, message: 'Email wajib diisi.' },
                                    { type: 'email', message: 'Format email tidak valid.' },
                                ]}
                            >
                                <Input
                                    size="large"
                                    placeholder="nama@perusahaan.com"
                                    prefix={<UserOutlined />}
                                    autoComplete="username"
                                />
                            </Form.Item>

                            <Form.Item
                                label="Password"
                                name="password"
                                rules={[{ required: true, message: 'Password wajib diisi.' }]}
                            >
                                <Input.Password
                                    size="large"
                                    placeholder="Masukkan password"
                                    autoComplete="current-password"
                                    prefix={<LockOutlined />}
                                    iconRender={(visible) =>
                                        visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                                    }
                                />
                            </Form.Item>

                            <div className="bolde-login-helper-row">
                                <span>
                                    <SafetyCertificateOutlined /> Koneksi aman
                                </span>
                                <span className="bolde-login-help-text">Hubungi HR jika akses bermasalah</span>
                            </div>

                            <Form.Item className="bolde-login-submit-item">
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    block
                                    size="large"
                                    loading={loading}
                                    className="bolde-login-submit"
                                >
                                    {loading ? 'Memproses...' : (
                                        <>
                                            Masuk
                                            <ArrowRightOutlined />
                                        </>
                                    )}
                                </Button>
                            </Form.Item>
                        </Form>

                        <div className="bolde-login-note">
                            Hanya untuk pengguna yang memiliki akses resmi BOLDe Access.
                        </div>
                    </div>

                    <div className="bolde-login-copyright">
                        © {new Date().getFullYear()} BOLDe Access · Internal Employee Portal
                    </div>
                </div>
            </section>
        </main>
    );
}

export default Login;
